<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container my-5" >
                <template #default>   <m-form-step-1 v-bind='{...{"formId":null,"redirectDirectLink":""},...{}}' :style='""' class="" ></m-form-step-1></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mFormStep1 from '@moeinmdn/miw-alpha-components/src/package/Form/FormStep/FormStep1/FormStep1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mFormStep1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
